/* External dependencies */
import { Col, Div, Row, Button } from 'atomize';
import React from 'react';

/* Local dependencies */
import formatMessage from '../../../intl/formatMessage';
import { rowStyle } from '../../form/FormStyles';
import Popup from '../../popup/Popup';
import PopupContent from '../../popup/PopupContent';
import SelectConsigneeProfile from './SelectConsigneeProfile';
import { prepareRows } from '../helper';
import { convertArrayToExcelBuffer } from '../../common/convert-array-to-excel-buffer';
import { convertArrayBufferToBase64 } from '../../common/convert-array-buffer-to-base64';
import { CreateConsigneeGoodSpecificationInput } from './redux/types';
import { createConsigneeGoodsSpecRequest } from './redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import PrimaryButton from '../../buttons/PrimaryButton';

interface GoodsPopup {
  onClose: () => void;
}

export function GoodsPopup(props: GoodsPopup) {
  const { onClose } = props;

  const dispatch = useDispatch();

  const { columns, consigneeProfile } = useSelector(
    (state: RootState) => state.createConsigneeGoodsSpecification,
  );

  async function onCreateReport() {
    const { columnsToGroup, columnsToSum, rows } = prepareRows(columns);

    const { buffer } = await convertArrayToExcelBuffer(rows);

    const rowsBase64 = await convertArrayBufferToBase64(buffer);

    const input: CreateConsigneeGoodSpecificationInput = {
      columnsToGroup: columnsToGroup.length > 0 ? columnsToGroup : null,
      columnsToSum,
      consigneeProfile,
      file: rowsBase64,
    };

    dispatch(createConsigneeGoodsSpecRequest(input));

    onClose();
  }

  return (
    <Popup title={formatMessage('fillFields')} onClose={onClose}>
      <PopupContent>
        <Div d="flex" flexDir="column" justify="center" align="center">
          <Row
            {...rowStyle}
            align="baseline"
            border={{ b: '1px solid' }}
            p={{ b: '1rem' }}
            borderColor="search_bg_color"
          >
            <Col>
              <SelectConsigneeProfile />
            </Col>
          </Row>

          <PrimaryButton
            icon="Plus"
            m={{ t: '15px' }}
            disabled={!Boolean(consigneeProfile)}
            onClick={onCreateReport}
          >
            {formatMessage('create')}
          </PrimaryButton>
        </Div>
      </PopupContent>
    </Popup>
  );
}
